import axios from "axios";
import api from "./API/api.js";

//创建一个axios的对象
const instance = axios.create({
  baseURL: "https://sajj.jlntech.cn/sajj/gthmmc/index.php",
/*   baseURL: "http://localhost/sajj/gthmmc/index.php", */
  /* baseURL: "http://192.168.0.187/sajj/gthmmc/index.php", */
  //baseURL会在发送请求时拼接在url参数前面
  timeout: 5000,
});

export function getlist(pageNo, pageNum, department, name, tag) {
  return instance.get(
    api.get.getlist +
      "&pageNo=" +
      pageNo +
      "&pageNum=" +
      pageNum +
      "&department=" +
      department +
      "&name=" +
      name +
      "&tag=" +
      tag
  );
}
export function getsslist(pageNo, pageNum, lsgx, name) {
  return instance.get(
    api.get.getlist +
      "&pageNo=" +
      pageNo +
      "&pageNum=" +
      pageNum +
      "&lsgx=" +
      lsgx +
      "&name=" +
      name
  );
}
export function getprovincelist(pageNo, pageNum, region, name) {
  return instance.get(
    api.get.getlist +
      "&pageNo=" +
      pageNo +
      "&pageNum=" +
      pageNum +
      "&region=" +
      region +
      "&name=" +
      name
  );
}
export function getcitylist(pageNo, pageNum, region, city, name) {
  return instance.get(
    api.get.getlist +
      "&pageNo=" +
      pageNo +
      "&pageNum=" +
      pageNum +
      "&region=" +
      region +
      "&city=" +
      city +
      "&name=" +
      name
  );
}
export function getdistlist(pageNo, pageNum, region, city, dist, name) {
  return instance.get(
    api.get.getlist +
      "&pageNo=" +
      pageNo +
      "&pageNum=" +
      pageNum +
      "&region=" +
      region +
      "&city=" +
      city +
      "&dist=" +
      dist +
      "&name=" +
      name
  );
}
export function getssdwb(lsgx, keyword) {
  return instance.get(api.get.getdwb + "&lsgx=" + lsgx + "&keyword=" + keyword);
}
export function getdwb(region, keyword) {
  return instance.get(
    api.get.getdwb + "&region=" + region + "&keyword=" + keyword
  );
}
export function getdwb2(region, city, keyword) {
  return instance.get(
    api.get.getdwb +
      "&region=" +
      region +
      "&city=" +
      city +
      "&keyword=" +
      keyword
  );
}
export function getdwb3(region, city, dist, keyword) {
  return instance.get(
    api.get.getdwb +
      "&region=" +
      region +
      "&city=" +
      city +
      "&dist=" +
      dist +
      "&keyword=" +
      keyword
  );
}
export function getsssb(region) {
  return instance.get(api.get.getsb + "&region=" + region);
}
export function getssxb(region) {
  return instance.get(api.get.getxb + "&region=" + region);
}
export function getssxb2(region, city) {
  return instance.get(api.get.getxb + "&region=" + region + "&city=" + city);
}
export function getjjphb() {
  return instance.get(api.get.getphb + "&showtype=1");
}
export function getjtphb() {
  return instance.get(api.get.getphb + "&showtype=2");
}
export function getbzsdw() {
  return instance.get(api.get.getphb + "&showtype=8");
}
export function getpro() {
  return instance.get(api.get.getpro);
}
export function getprovince() {
  return instance.get(api.get.getphb + "&showtype=3");
}
export function getcity() {
  return instance.get(api.get.getphb + "&showtype=9");
}
export function getdist() {
  return instance.get(api.get.getphb + "&showtype=10");
}
export function xgword(title, pword, newpword) {
  return instance.post(
    api.post.xgword +
      "&title=" +
      title +
      "&pword=" +
      pword +
      "&newpword=" +
      newpword
  );
}
